export enum PayrollVariableType {
Days,
Hours,
Value,
Year,
}
